import React from "react"
import "./botonesaccion.css"
import { BotonDelete, BotonEditar, BotonInformacion } from '../Plantillas/Botones';
import {convertStrToJson, doDownload} from "../../Global";

const BotonesAccion = (props) => {
    let data = props.rowsel;
    const tipoDoc = data.Tipo === "NC" ? "07" : "06";
    const oldXmlUrl = `${process.env.REACT_APP_FACT_BASE_URL}/datos/${data.Ruc}/xml/${tipoDoc}/${data.Ruc}-${tipoDoc}-${data.SerieCD}-${data.NumeroCE.replace(/^0+/g, '')}.xml`;
    const oldCdrUrl = `${process.env.REACT_APP_FACT_BASE_URL}/datos/${data.Ruc}/xml/${tipoDoc}/R-${data.Ruc}-${tipoDoc}-${data.SerieCD}-${data.NumeroCE.replace(/^0+/g, '')}.zip`;

    let resEnvioSunat = convertStrToJson(data.respuestaAnulacionSunat)
    let xml = resEnvioSunat.xmlFirmado && resEnvioSunat.xmlFirmado.length ? resEnvioSunat.xmlFirmado : oldXmlUrl;

    if (xml) {
        xml = xml.replace("http://", "https://")
    }

    let cdrZip = resEnvioSunat.cdrZip && resEnvioSunat.cdrZip.length ? resEnvioSunat.cdrZip : oldCdrUrl;

    if (cdrZip) {
        cdrZip = cdrZip.replace("http://", "https://")
    }

    const isAnulado = props.rowsel.Estado === 'ANULADA';

    return (
        <div align="left">
            <button
                className="btn btn-outline-primary fas fa-cloud-upload-alt mr-2"

                title="enviar SUNAT"
                onClick={
                    () => {
                        props.onclickSendSUNAT(props.rowsel)
                    }
                }
                disabled={props.rowsel.Estado !== 'PENDIENTE' || isAnulado}

            />
            <BotonEditar
                className="mr-2"
                hidden={props.rowsel.Estado !== 'PENDIENTE' || isAnulado}
                onClick={e => { e.preventDefault(); props.history.push(`/note/${props.rowsel.idNc}`) }}
                title="Editar"
            />
            {/* <a href="#"  hidden={props.rowsel.Estado !== 'PENDIENTE'} onClick={e => {
                e.preventDefault();
                props.history.push(`/note/${props.rowsel.idNc}`)
            }}>Editar</a> */}
            <a
                className={`btn btn-outline-success fas fa-download mr-2 ml-1 ${isAnulado ? 'disabled' : ''}`}
                title="descarga xml"
                target="_blank"
                href={xml}
                onClick={e => {
                    if (isAnulado) {
                        e.preventDefault()
                        return
                    }
                    e.preventDefault()
                    doDownload(xml, `${data.Ruc}-${tipoDoc}-${data.SerieCD}-${data.NumeroCE.replace(/^0+/g, '')}.xml`)
                }}
            />
            <a
                className={`btn btn-outline-success fas fa-file-archive mr-2 ${isAnulado ? 'disabled' : ''}`}
                title="descarga cdr"
                target="_blank"
                href={cdrZip}
                onClick={e => {
                    if (isAnulado) {
                        e.preventDefault()
                    }
                }}
            />
            <button
                className="btn btn-outline-danger fas fa-file-pdf mr-2"
                title="descarga pdf"
                onClick={
                    () => {
                        props.downloadPDF(props.rowsel)
                    }
                }
                disabled={isAnulado}
            />
            <button
                className="btn btn-outline-info fas fa-envelope-open-text mr-2"
                title="enviar correo electrónico"
                onClick={
                    () => {
                        props.enviarCorreo(props.rowsel)
                    }
                }
                disabled={props.rowsel.Estado !== 'ACEPTADA' || isAnulado}
            />

            <button
                className="btn btn-outline-danger fas fa-times mr-2"
                title="anular nota"
                onClick={
                    () => {
                        props.anularNota(props.rowsel)
                    }
                }
                disabled={isAnulado}
            />

            <button
                className="btn btn-outline-warning fas fa-ticket-alt mr-2"
                title="consultar ticket"
                onClick={
                    () => {
                        props.consultaTicket(props.rowsel)
                    }
                }
            />

        </div>
    )
}

export default BotonesAccion
